// src/pages/RoomCheckoutPage.js

import React, { useEffect, useState, useContext } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  CloseButton
} from 'react-bootstrap';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
  addDoc,
  updateDoc,
  serverTimestamp,
  limit
} from 'firebase/firestore';
import { db } from '../FireBase';
import { AuthContext } from '../context/AuthContext';
import CouponPopup from '../components/CouponPopup';
import Slotpopup from '../components/slotComponent';
import ToastNotification from '../components/ToastAlert';
import SuccessModal from '../components/SuccessModal';
import Loading from '../components/Loading';
import initiateRazorpayPayment from '../components/Razorpay';
import { v4 as uuidv4 } from 'uuid';
import GuestFormModal from '../components/GuestFormModal';
import JsConfetti from "../components/jsConfetti";


import {
  BedDouble,
  Users,
  Plus,
  TicketPercent,
  Utensils,
  Receipt,
  Wallet,
  IndianRupee,
  LoaderCircle,
  CalendarClock,
  CloudMoon
} from 'lucide-react';
import '../css/checkout.css';
import Skeleton from 'react-loading-skeleton';
import PaymentLoading from '../components/PaymentLoading';

export default function RoomCheckoutPage() {
    const location = useLocation();
  const { currentUser } = useContext(AuthContext);
  const { id: roomId } = useParams();
  const navigate = useNavigate();
  const [room, setRoom] = useState(null);
  const [fetchedCoupons, setFetchedCoupons] = useState([]);
  const [coupon, setCoupon] = useState('');
  const [discount, setDiscount] = useState(0);
  const [showCoupon, setShowCoupon] = useState(false);
  const [showGuestModal, setShowGuestModal] = useState(false);
  const [guestList, setGuestList] = useState([]);
  // const [includeBreakfast, setIncludeBreakfast] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("razorpay");

  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');
  const [orderPlaced, setOrderPlaced] = useState(false);
  const STORAGE_KEY = 'bookingSearch';
  const [range, setRange]= useState({ from: undefined, to: undefined });
  const [nights,setNights]= useState();
  const [maxGuestCount,setMaxGuestCount]= useState();
  const guestsList = [
    '1 Adult','2 Adults','3 Adults','4 Adults','Family (2+2)',
  ];

  const [triggerConfetti, setTriggerConfetti] = useState(false);
  const [guests, setGuests]= useState(guestsList[0]);  
  const [roomCount, setRoomCount] = useState(1);
  

    const bookingData = location.state || {};
  
    console.log(bookingData)
  useEffect(() => {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved) {
    try {
      const { from, to, guests: g, guestCount, roomCount } = JSON.parse(saved);

      setMaxGuestCount(guestCount || 1);
      const parsedFrom = from ? new Date(from) : undefined;
      const parsedTo = to ? new Date(to) : undefined;

      setRange({ from: parsedFrom, to: parsedTo });

      if (parsedFrom && parsedTo) {
        const timeDiff = parsedTo.getTime() - parsedFrom.getTime();
        setNights(Math.ceil(timeDiff / (1000 * 60 * 60 * 24)));
      }

      if (guestsList.includes(g)) setGuests(g);

      // ✅ new
      if (roomCount) {
        setRoomCount(roomCount);
      }

    } catch (err) {
      console.warn("Error parsing saved booking data", err);
    }
  }
  const totalRoomPrice =(bookingData.finalPrice * nights * bookingData.roomCount).toFixed(2)
}, []);

    const formatDateForOrder = (date) => {
    return date?.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  const formatDate = (date) => {
    return date?.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  useEffect(() => {
    if (!currentUser) {
      navigate('/login');
      return;
    }
    fetchCoupons();
    fetchRoom();
  }, [currentUser, roomId]);

  const fetchRoom = async () => {
    const ref = doc(db, 'rooms', roomId);
    const snap = await getDoc(ref);
    if (snap.exists()) setRoom({ id: snap.id, ...snap.data() });
    setLoading(false);

  };

  const fetchCoupons = async () => {
    const q = query(collection(db, 'coupons'), where('active', '==', true));
    const querySnapshot = await getDocs(q);
    const coupons = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setFetchedCoupons(coupons);
  };


  const pricePerNight = room?.pricePerNight || 0;
  const subtotal = nights ? pricePerNight * nights : 0;
  const grandTotal = subtotal - discount;
  

  const applyCoupon = () => {
    const code = coupon.trim().toUpperCase();
    const match = fetchedCoupons.find(c => c.code.toUpperCase() === code);
  
    if (!match) {
      setDiscount(0);
      setToastMessage('Invalid or expired coupon.');
      setToastVariant('danger');
      setShowToast(true);
      return;
    }
  
    // ✅ check user usage against maxUsage
    const currentUserId = currentUser?.cusmid; // adjust if your user id field is different
    const userUsage = match.userUsage?.[currentUserId] || 0;
  
    if (userUsage >= match.maxUsage) {
      setDiscount(0);
      setToastMessage(`You have already used coupon "${match.code}" the maximum allowed times.`);
      setToastVariant('warning');
      setShowToast(true);
      return;
    }
  
    // ✅ if valid, apply coupon
    setDiscount(match.discountValue || 0);
    setShowCoupon(false);
    setToastMessage(`Coupon "${match.code}" applied!`);
    setToastVariant('success');
    setShowToast(true);

    setTriggerConfetti(true);
    setTimeout(() => setTriggerConfetti(false), 6000);
  };
  

  const handleRemoveGuest = (index) => {
    setGuestList(prev => prev.filter((_, i) => i !== index));
  };

  const handleBookRoom = async () => {
    if (guestList.length === 0) {
      setToastMessage('Please add at least one guest.');
      setToastVariant('danger');
      setShowToast(true);
      return;
    }
    const orderId = 'KAB' + uuidv4().slice(0, 8).toUpperCase();
    const transactionId = 'TR' + Date.now().toString().slice(-6);
    
   const finalCost = bookingData.finalPrice * nights - discount;


const orderData = {
  userId: currentUser.cusmid,
  orderId,
  createdAt: new Date().toISOString(),
  roomId: room.id,
  roomName: room.name,
  roomImage: room.roomImage,
  discount,
  cost: finalCost, // ✅ final total after discount
  paymentMethod,
  guests: guestList,
  adultCount: bookingData.adults,
  childCount:bookingData.children,
  perNightcost:bookingData.finalPrice,
  checkIn: formatDateForOrder(range.from),
  checkOut: formatDateForOrder(range.to),
  stayDays: nights,
  status: 'payment-pending',
  bookingType: 'online',
  transactionId,
  roomCount:bookingData.roomCount,
  breakdown: bookingData.breakdown, // ✅ save child pricing breakdown
  paymentStatus:"Pending",
};

  console.log(orderData)
const transactionData = {
  userId: currentUser.cusmid,
  orderId,
  transactionId,
  paymentAmount: finalCost,
  paymentDate: serverTimestamp(),
  type: 'ROOM_BOOKING',
};


    try {
      setLoading(true);
      await addDoc(collection(db, 'room_bookings'), orderData);
      await addDoc(collection(db, 'transactions'), transactionData);
  
      let razorpayId ='' 
      if (paymentMethod === 'razorpay') {
        const success = await initiateRazorpayPayment(finalCost, transactionId, currentUser.phoneNumber,orderId);
        if (!success) throw new Error('Payment failed');
        razorpayId=success.razorpay_payment_id;
        console.log("payment rec")
          const q = query(
        collection(db, "transactions"),
        where("orderId", "==", orderId),
        limit(1)
      );
      const snap = await getDocs(q);
      if (!snap.empty) {
        await updateDoc(snap.docs[0].ref, {
          razorpayId,
          status: "paid",
        });
      }
      }
  
    
    
      if (coupon) {
        const matched = fetchedCoupons.find(c => c.code.toUpperCase() === coupon.trim().toUpperCase());
        if (matched) {
          const cref = doc(db, 'coupons', matched.id);
          const cdoc = await getDoc(cref);
          const usage = cdoc.data().userUsage || {};
          const currentCount = usage[currentUser.cusmid] || 0;
          await updateDoc(cref, { [`userUsage.${currentUser.cusmid}`]: currentCount + 1 });
          await addDoc(collection(db, 'coupon_history'), {
            couponCode: matched.code,
            couponId: matched.id,
            userId: currentUser.cusmid,
            orderId,
            usedAt: serverTimestamp()
          });
        }
      }
  
      setOrderPlaced(true);
      
    } catch (err) {
      console.error(err);
      setToastMessage('Error placing booking.');
      setToastVariant('danger');
      setShowToast(true);
    } finally {
      setLoading(false);
    }
  };
  
  const renderSkeleton = () => (
    <Container className="my-4">
      <Row>
        <Col md={7} className="pe-md-5 mb-3">
          <Skeleton height={40} width={200} />
          <Skeleton height={200} className="mb-3" />
          <Skeleton count={3} height={20} className="mb-2" />
        </Col>
        <Col md={5}>
          <Skeleton height={60} className="mb-3" />
          <Skeleton height={100} className="mb-3" />
          <Skeleton height={150} className="mb-3" />
          <Skeleton height={80} className="mb-3" />
          <Skeleton height={50} />
        </Col>
      </Row>
    </Container>
  );
    if (!room) return renderSkeleton();

  return (
    <Container className="my-4" style={{ paddingBottom: 60 }}>
      <JsConfetti
        fire={triggerConfetti}
        onDone={() => setTriggerConfetti(false)}
      />
      <ToastNotification show={showToast} onClose={() => setShowToast(false)} message={toastMessage} variant={toastVariant} />
      {orderPlaced && <SuccessModal show onClose={() => navigate('/')} />}
        {loading && <PaymentLoading show/>}
      <center><h1 style={{color:'#54b435'}}>Booking</h1></center>
      <br/>
      <Row>
        <Col md={7} className="pe-md-5 mb-3">
        
          <Card className="mb-3 shadow-sm room-card-checkout">
            <Card.Img variant="top" src={room.roomImage} style={{ objectFit: 'cover', height: 200, borderRadius: "15px 15px 0px 0px" }} />
            <Card.Body>
              <Card.Title className="fw-bold">{room.name} x {room.roomCount}</Card.Title>
              <p><IndianRupee size={18} className="me-1" />{bookingData.finalPrice.toFixed(2)} × {nights} night(s)<br />
              <Users size={18} className="me-1" />{room.occupancy} Max Guest</p>
            </Card.Body>
          </Card>

          <Card className="mb-3 shadow-sm room-card-checkout">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <h5><Users size={18} className="me-2" />Guests</h5>
                <Button size="sm" className='btn-own-2' onClick={() => setShowGuestModal(true)}  disabled={guestList.length >= maxGuestCount}>
                  <Plus size={16} className="me-1" /> Add Guest
                </Button>
              </div>
              <ul className="mt-2 ps-3">
                {guestList.length === 0 ? (
                  <li className="text-muted">👤 No guest details found</li>
                ) : (
                  guestList.map((guest, index) => (
                    <li key={index} className="d-flex justify-content-between align-items-center">
                      {guest.name} ({guest.phone})
                      <CloseButton onClick={() => handleRemoveGuest(index)} />
                    </li>
                  ))
                )}
              </ul>

            </Card.Body>
          </Card>
        </Col>

        <Col md={5} style={{ position: 'sticky', top: 0 }}>
        <Card className="mb-3 shadow-sm room-card-checkout">
  <Card.Body className="d-flex justify-content-between align-items-center">
    <div className="d-flex align-items-center gap-2">
      <strong><TicketPercent size={18} className="me-2" />Have a coupon?</strong>
      {discount > 0 && <span className="text-success">Applied!!</span>}
    </div>
    <Button size="sm" className='btn-own-2' onClick={() => setShowCoupon(true)}>Add</Button>
  </Card.Body>
</Card>


          {/* <Card className="mb-3 shadow-sm room-card-checkout">
            <Card.Body>
              <h5><Utensils size={18} className="me-2" />Breakfast</h5>
              <Form.Check
                type="checkbox"
                label={`Add Breakfast (₹300/person/day)`}
                checked={includeBreakfast}
                onChange={() => setIncludeBreakfast(!includeBreakfast)}
              />
            </Card.Body>
          </Card> */}
<Card className="mb-3 shadow-sm room-card-checkout">
  <Card.Body>
    <h5><Receipt className="me-2" />Booking Summary</h5>
    <p><CalendarClock size={18}/> Check-in: {formatDate(new Date(bookingData.checkIn))}</p>
    <p><CalendarClock size={18}/> Check-out: {formatDate(new Date(bookingData.checkOut))}</p>
    <p><CloudMoon size={18}/> Nights: {nights}</p>
    <p><Users size={18}/> Guests: {bookingData.totalGuests} 
       (Adults: {bookingData.adults}, Children: {bookingData.children})</p>

    <hr />
    {/* Base Room Price */}
    <p><BedDouble size={18} className="me-2"/> Room Base Price: 
      ₹{(bookingData.finalPrice * nights * bookingData.roomCount).toFixed(2)}
    </p>

    {/* Children Charges */}
    {bookingData.breakdown?.under7 > 0 && (
      <p><Users size={18} className="me-2"/> Children (0-7 yrs): Free × {bookingData.breakdown.under7}</p>
    )}
    {bookingData.breakdown?.between8And12 > 0 && (
      <p><Users size={18} className="me-2"/> Children (7-12 yrs): Half Price × {bookingData.breakdown.between8And12}</p>
    )}
    {bookingData.breakdown?.above12 > 0 && (
      <p><Users size={18} className="me-2"/> Children (12+ yrs): Extra Bed/Adult Rate × {bookingData.breakdown.above12}</p>
    )}

    {/* Discount */}
    {discount > 0 && (
      <p className="text-success">
        <TicketPercent size={18} className="me-2"/> Discount: -₹{discount.toFixed(2)}
      </p>
    )}

    <hr />
    {/* Final Cost */}
    <h6 className="fw-bold d-flex align-items-center">
      <IndianRupee size={18} className="me-2"/> 
      Total Cost: ₹{(bookingData.finalPrice * nights - discount).toFixed(2)}
    </h6>
  </Card.Body>
</Card>



          <Card className="mb-3 shadow-sm room-card-checkout">
            <Card.Body>
              <h5><Wallet size={18} className="me-2" />Payment Method</h5>
              {/* <Form.Check
                type="radio"
                label="Cash on Arrival"
                name="payment"
                value="cod"
                checked={paymentMethod === 'cod'}
                onChange={e => setPaymentMethod(e.target.value)}
               
              /> */}
              <Form.Check
                type="radio"
                label="Razorpay (UPI / Card / Wallets)"
                name="payment"
                value="razorpay"
                checked={paymentMethod === 'razorpay'}
                onChange={e => setPaymentMethod(e.target.value)}
              
              />
              <p style={{color:'red',fontSize:'12px'}}>Note: *Do not close the app while payment process!</p>
            </Card.Body>
          </Card>

          <Button
            className="w-100 d-flex align-items-center justify-content-center gap-2 btn-own"
            onClick={handleBookRoom}
            disabled={loading}
            style={{height:'50px'}}
          >
            {loading ? <><LoaderCircle size={16} className="spin" /> Processing...</> : '💳 Make Payment'}
          </Button>
        </Col>
      </Row>

      <CouponPopup
        show={showCoupon}
        handleClose={() => setShowCoupon(false)}
        isMobile={window.innerWidth < 768}
        coupon={coupon}
        setCoupon={setCoupon}
        applyCoupon={applyCoupon}
        availableCoupons={fetchedCoupons}
      />

    

      <GuestFormModal
        show={showGuestModal}
        handleClose={() => setShowGuestModal(false)}
        setGuestList={setGuestList}
        guestList={guestList}
        maxGuests={room.occupancy}
      />
    </Container>
  );
}
